import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.274 8A3.274 3.274 0 1 1 8 4.726 3.276 3.276 0 0 1 11.274 8Zm.5 3.247a.53.53 0 1 1-.534-.533.531.531 0 0 1 .534.533Zm.56-.06a1.155 1.155 0 0 1-1.147 1.147H7.753a4.338 4.338 0 1 1 4.581-4.747ZM12 2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z';
const draw24px =
  'M17.46,12A5.46,5.46,0,1,1,12,6.54,5.47,5.47,0,0,1,17.46,12Zm.83,5.41a.89.89,0,1,1-.89-.89A.89.89,0,0,1,18.29,17.41Zm.93-.1a1.92,1.92,0,0,1-1.91,1.91H11.59a7.23,7.23,0,1,1,7.63-7.91ZM18.67,2H5.33A3.33,3.33,0,0,0,2,5.33V18.67A3.33,3.33,0,0,0,5.33,22H18.67A3.33,3.33,0,0,0,22,18.67V5.33A3.33,3.33,0,0,0,18.67,2Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoPlanGridFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'logoPlanGridFilled')) as IconWithRender;

LogoPlanGridFilledIcon.displayName = 'LogoPlanGridFilledIcon';
LogoPlanGridFilledIcon.propTypes = Icon.propTypes;
LogoPlanGridFilledIcon.renderIcon = (props) => (
  <LogoPlanGridFilledIcon {...props} />
);
export default LogoPlanGridFilledIcon;
